import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { clearTypeahed, fetchTicketPrefixEnumData } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class DeviceTicketPrefixTypeahead extends Component {
    static propTypes = {
        fetchTicketPrefixEnumData: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        isClearable: PropTypes.bool,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.object
        ]),
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        isClearable: false,
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchTicketPrefixEnumData(DeviceTicketPrefixTypeahead.name, 'ticketPrefixKind');
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const {
            value,
            error,
            isClearable,
            disabled,
            t,
            clearTypeahed,
            renderMultiSuggestion,
            onChangeSuggestion
        } = this.props;

        const options = this.props.suggestions.map(ticketPrefix =>
            ({ label: ticketPrefix.alternativeName, id: ticketPrefix.id, name: ticketPrefix.name })
        );

        return (
            <MultiTypeahead
                options={options}
                isLoading={this.state.isLoading}
                value={value}
                titleId="ticketPrefix"
                animatedPlaceholder
                onChangeSuggestion={onChangeSuggestion}
                onFocus={this.onFocus}
                formatOptionLabel={renderMultiSuggestion}
                handleSuggestionsClearRequested={clearTypeahed}
                error={error}
                isClearable={isClearable}
                disabled={disabled}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === DeviceTicketPrefixTypeahead.name
            ? typeahead.list
            : DeviceTicketPrefixTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchTicketPrefixEnumData,
    clearTypeahed
})(DeviceTicketPrefixTypeahead);
